import React, { useEffect, useState } from 'react'; // eslint-disable-line
import { isMobileOnly, isTablet } from 'react-device-detect';

import useMobileOrientation from './useMobileOrientation';

export default function useIsMobile() {
  const [mobile, setMobile] = useState(false);
  const { isPortrait } = useMobileOrientation();

  useEffect(() => {
    if (isMobileOnly || (isTablet && isPortrait)){
      setMobile(true);
    }
  }, [isPortrait]);

  return mobile;
}
